import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import WPHeading from "../../../../../packages/WPHeading";
import WPSideNav from "../../../../../packages/WPSideNav/WPSideNav";
import { WPVerticalTabsList } from "../../../../../packages/WPTabs/WPVerticalTabs";

import UserLicenseSupport from "./UserLicenseSupport/UserLicenseSupport";
import { UserDefaultLicenseCard, UserLicenseCard } from "./UserLicenseCard";
import { LICENSE_SIDENAV_COLLAPSE_BREAKPOINT } from "./UserLicenseDetails.constants";

import { HIDDEN_LICENSE_IDS } from "../../../../../constants/LicenseManagement.constants";

import "./UserLicenseDetails.scss";

const UserLicenseDetails = ({ licenseData }) => {
  const { t } = useTranslation();
  const safeLicenseData = Array.isArray(licenseData) ? licenseData : [];
  const tabLicenses = safeLicenseData.filter(
    (license) => !HIDDEN_LICENSE_IDS.includes(Number(license?.id)),
  );

  const [activeTab, setActiveTab] = useState(tabLicenses[0]?.id);

  useEffect(() => {
    setActiveTab((prevActiveTab) => {
      if (!tabLicenses.length) return undefined;
      const hasActiveTab = tabLicenses.some(
        (license) => license.id === prevActiveTab,
      );
      return hasActiveTab ? prevActiveTab : tabLicenses[0].id;
    });
  }, [tabLicenses]);

  const activeLicense = useMemo(() => {
    if (safeLicenseData.length === 1) return safeLicenseData[0];
    return (
      safeLicenseData.find((license) => license.id === activeTab) ||
      tabLicenses[0] ||
      safeLicenseData[0]
    );
  }, [activeTab, safeLicenseData, tabLicenses]);

  const showDefaultCard = !safeLicenseData.length;

  return (
    <div className="user-license-details-section">
      <WPHeading
        text={t("licenseProfile.licenseDetails")}
        size="small"
        className="license-details-title"
        id="license-details-title"
      />
      <div className="user-license-details-container">
        {showDefaultCard ? (
          <div className="user-license-details-content">
            <UserDefaultLicenseCard
              description={"licenseProfile.publicDefaultText"}
            />
          </div>
        ) : (
          <>
            {tabLicenses?.length > 0 && (
              <WPSideNav
                className="user-license-sidenav"
                collapseBreakpoint={LICENSE_SIDENAV_COLLAPSE_BREAKPOINT}
              >
                <WPVerticalTabsList
                  tabs={tabLicenses}
                  onTabClick={setActiveTab}
                  activeTab={activeTab}
                />
              </WPSideNav>
            )}
            <div className="user-license-details-content">
              <UserLicenseCard license={activeLicense} />
              <div className="user-license-support-global">
                <UserLicenseSupport />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserLicenseDetails;
